import { get } from 'lodash';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getWaitingListTimesShop } from '../waitingList/selectors';
import { getShopByRoute } from '../shops/selectors';
import { getShopObject } from '../reservation/selectors';
import { getShopObjectFromReceipt } from '../receipt/selectors';
import { getCampaignShop } from '../campaign/selectors';

const WithShopCurrency = compose(
  withRouter,
  connect((state, ownProps) => {
    const shop =
      getShopByRoute(state, ownProps.params.shopRoute) ||
      getShopObject(state) ||
      getWaitingListTimesShop(state) ||
      getShopObjectFromReceipt(state) ||
      getCampaignShop(state);
    return {
      currency: get(shop, 'currency', 'USD'),
    };
  }),
);

export default WithShopCurrency;



// WEBPACK FOOTER //
// ./src/app/hoc/WithShopCurrency.js